// Конфигурация API в зависимости от режима
// VITE_API_URL задаётся в .env.test / .env.production
export const API_BASE_URL = import.meta.env.VITE_API_URL
    || (import.meta.env.DEV
        ? 'http://localhost:8000'
        : 'https://colnishko.ru/api');

export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}; 